module.exports = __webpack_public_path__ + "img/警語.34610254.jpg";